<template>
    <form>

            <b-modal :active.sync="isComponentModalActive"
                     has-modal-card full-screen >

                <div class="modal-card ">
                    <header class="modal-card-head"  >
 
                    </header>
                    <section class="modal-card-body"  >
                        <b-loading  :active.sync="isFullScreenLoading" ></b-loading>

                        <b-tabs @input="inputChange" >
                            <b-tab-item label="Pictures"  v-for="grpAuth in classifiGrpAuth" :key="grpAuth.id">
                                <template #header>
                                    <span> {{grpAuth.name}} </span>
                                </template>

                                        <div class="columns">
                                            <div class="column">
                                                <b-table
                                                        :data="isEmpty ? [] : dataListOfLabStatusWithPathoEachGrpAuth(grpAuth.id) "
                                                        bordered
                                                        striped
                                                        narrowed
                                                        hoverable
                                                        focusable
                                                        mobile-cards
                                                        paginated
                                                        :per-page="perPage"
                                                        :current-page.sync="currentPage"
                                                >

                                                    <b-table-column  label="Assigned to"  v-slot="props">
                                                        <p class="has-text-dark is-size-5">  {{ props.row.user_fn }} </p>
                                                    </b-table-column>

<!--                                                    <b-table-column  label="#"  v-slot="props">-->
<!--                                                        <b-field   v-for=" data in getGroup( props.row.id ).data "  :key="data.status_id" >-->
<!--                                                            <b-button type="is-info is-light"-->
<!--                                                                      @click="viewDetail(data.status_id,data.status_name,props.row.user_fn,props.row.user_id,props.row.id)">-->
<!--                                                                <span>{{data.status_name}}  <b-tag rounded  type="is-info"> {{data.data.length}} </b-tag> </span>-->
<!--                                                            </b-button>-->
<!--                                                        </b-field>-->

<!--                                                    </b-table-column>-->



                                                <b-table-column  label="Assigned" centered v-slot="props">
                                                    <b-button type="is-info is-light" v-if="getCountStatusWithUserID(props.row.user_id, 2)>0"
                                                              @click="viewDetail(2,'Assigned',props.row.user_fn,props.row.user_id,props.row.id) ">
                                                        <span> Assigned  <b-tag rounded  type="is-info"> {{getCountStatusWithUserID(props.row.user_id, 2)}} </b-tag> </span>
                                                    </b-button>
                                                    <b class="has-text-grey" v-else>{{getCountStatusWithUserID(props.row.user_id, props.row.id)}} </b>
                                                </b-table-column>


                                                <b-table-column  label="Prepared"  centered v-slot="props">
                                                    <b-button type="is-info is-light" v-if="getCountStatusWithUserID(props.row.user_id, 3)>0"
                                                              @click="viewDetail(3,'Prepared',props.row.user_fn,props.row.user_id,props.row.id) " >
                                                        <span> Prepared  <b-tag rounded  type="is-info"> {{getCountStatusWithUserID(props.row.user_id, 3)}} </b-tag> </span>
                                                    </b-button>
                                                    <b class="has-text-grey" v-else  >{{getCountStatusWithUserID(props.row.user_id, 3)}} </b>
                                                </b-table-column>

                                                <b-table-column  label="Draft" centered  v-slot="props">
                                                    <b-button type="is-info is-light" v-if="getCountStatusWithUserID(props.row.user_id, 4)>0"
                                                              @click="viewDetail(4,'Draft',props.row.user_fn,props.row.user_id,props.row.id) " >
                                                        <span> Draft  <b-tag rounded  type="is-info"> {{getCountStatusWithUserID(props.row.user_id, 4)}} </b-tag> </span>
                                                    </b-button>
                                                    <b class="has-text-grey" v-else>{{getCountStatusWithUserID(props.row.user_id, 4)}} </b>
                                                </b-table-column>

                                                <b-table-column  label="Publish (Incompleted)"  centered v-slot="props">
                                                    <b-button type="is-info is-light" v-if="getCountStatusWithUserID(props.row.user_id, 5)>0"
                                                              @click="viewDetail(5,'Publish (Incompleted)',props.row.user_fn,props.row.user_id,props.row.id) " >
                                                        <span> Publish (Incompleted)  <b-tag rounded  type="is-info"> {{getCountStatusWithUserID(props.row.user_id, 5)}} </b-tag> </span>
                                                    </b-button>
                                                    <b class="has-text-grey" v-else>{{getCountStatusWithUserID(props.row.user_id, 5)}} </b>
                                                </b-table-column>


                                                    <template slot="empty">
                                                        <section class="section">
                                                            <div class="content has-text-grey has-text-centered">
                                                                <p>
                                                                    <b-icon
                                                                            icon="emoticon-sad"
                                                                            size="is-large">
                                                                    </b-icon>
                                                                </p>
                                                                <p>Nothing here.</p>
                                                            </div>
                                                        </section>
                                                    </template>


                                                </b-table>
                                            </div>
                                            <div class="column">
                                                <DetailEachDashboardLabNonStatus
                                                        v-if="user_id_Selected"
                                                        :user_fn="user_fn_Selected"
                                                        :user_id="user_id_Selected"
                                                        :status_id="status_id_Selected"
                                                        :status_name="status_name_Selected"
                                                        :data_Selected = "data_Selected"
                                                        @saveChanged = "saveChanged"
                                                />
                                            </div>
                                        </div>


                            </b-tab-item>

                        </b-tabs>



                    </section>
                    <footer class="modal-card-foot">
                        <b-button size="is-medium" type="is-danger"
                                  icon-left="close" @click="$emit('close')">
                            Close
                        </b-button>

                    </footer>



                </div>

            </b-modal>
        </form>

</template>

<script>
    import axios from "axios";
    import { getBaseURLforBackEnd , getConfigAxios }  from '@/utils.js'
    import DetailEachDashboardLabNonStatus from "./DetailEachDashboardLabNonStatus";
    import { mapState } from "vuex";

    export default {
        name: "PanelOfLabNonStatus",
        components:{
            DetailEachDashboardLabNonStatus
        },
        mounted() {
            this.getData()
        },
        props:{
            isComponentModalActive : Boolean
        },
        computed:{
            ...mapState({
                access_token: state => state.master_data.access_token,
            }),

            classifiGrpAuth:function () {
                var tmpObj = []

                this.dataListOfLabStatusWithPathoAll.forEach(dat=>{
                    const tmp =   tmpObj.find(datTmpObj=>{
                       return  datTmpObj.id === dat.id_grp_auth
                    })

                    if(!tmp){
                        tmpObj.push({"id": dat.id_grp_auth ,"name":dat.grp_auth_name })
                    }

                })

                return tmpObj
            },
        },
        methods:{
            saveChanged(){
                // const tmpActiveTab = this.activeTab
                this.getData()
                  .then(()=>{

                      this.user_fn_Selected = ""
                      this.user_id_Selected = null
                      this.status_id_Selected = null
                      this.status_name_Selected = ""
                      this.data_Selected = {}

                  })

            },
            getCountStatusWithUserID(_userID,_StatusID){
                // console.log(_userID+'   '+_StatusID)
                //
              const tmp =   this.dataListOfLabStatusWithPathoAll.find(dat=>{
                    return dat.user_id === _userID
                })

            if(tmp){
                const  tmp1 = tmp.data.find(dat=>{
                    return  dat.status_id === _StatusID
                })
                if(tmp1){
                    return tmp1.data.length
                }

            }


            return  0

            },


            inputChange(){
                // this.data_Selected =  Object.assign( {} ,{})
                this.data_Selected ={}
                this.user_fn_Selected = ""
                this.user_id_Selected = null
                this.status_id_Selected = null
                this.status_name_Selected = ""
            },
            dataListOfLabStatusWithPathoEachGrpAuth:function(_idauth){
                return this.dataListOfLabStatusWithPathoAll.filter(dat=>{
                    return dat.id_grp_auth === _idauth
                })
            },

            viewDetail(_status_id,_status_name,_user_fn,_user_id,_mainid){

                    this.user_fn_Selected = _user_fn
                    this.user_id_Selected = _user_id
                    this.status_id_Selected = _status_id
                    this.status_name_Selected = _status_name


                const tmp = this.dataListOfLabStatusWithPathoAll.find(dat=>{
                    return dat.id === _mainid
                })


                const tmpData = tmp.data.find(dat=>{
                    return dat.status_id === _status_id
                })

                this.data_Selected = tmpData




            },
            getGroup(_id) {
                const tmp = this.dataListOfLabStatusWithPathoAll.find(dat=>{
                    return dat.id === _id
                })
                // console.log(tmp)
                return tmp

            },
            getData() {
                const vm = this
                this.isFullScreenLoading = true

                return new Promise((resolve) => {

                    axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                    axios.post(`${getBaseURLforBackEnd()}/api/listoflabstatuswithpathoall`, getConfigAxios())
                        .then((res) => {
                            vm.dataListOfLabStatusWithPathoAll = res.data
                            vm.isFullScreenLoading = false
                            resolve(res.data)
                        })
                        .catch((err) => {
                            vm.$buefy.toast.open({
                                duration: 5000,
                                message: `${err.message}`,
                                position: 'is-bottom',
                                type: 'is-danger'
                            })
                            vm.isFullScreenLoading = false
                        })
                })
            }
        },
        data(){
            return {
                isFullScreenLoading : false,
                dataListOfLabStatusWithPathoAll : [],

                isEmpty  : false,
                perPage : 20 ,
                currentPage : 1,


                user_fn_Selected : "",
                user_id_Selected : null,
                status_id_Selected : null,
                status_name_Selected : "",
                data_Selected : {} ,
                radioButton : '',


                activeTab: 0,

            }
        }
    }
</script>

<style scoped>

</style>